import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeeRehireData = (from,to,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeRehires/list?from="+from+"&to="+to+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getEmployeeRehireById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeRehires/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    validateEmployeeRehire = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeRehires/validateDeputy"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    addEmployeeRehire = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeRehires/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editEmployeeRehire = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeRehires/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employee Rehire/services/apiservices.js